define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 文字、图标的朝向方式。
     *
     * @exports EnumRotateMode
     * 
     * @see IconSymbol#rotateMode
     * @see TextSymbol#rotateMode
     */
    var EnumRotateMode = {
        /**
         * 固定朝向。
         * @type {Number}
         * @constant
         */
        NO_ROTATE: 0,

        /**
         * 朝向屏幕。
         * @type {Number}
         * @constant
         */
        TO_SCREEN: 1,

        /**
         * 沿指定轴朝向屏幕。
         * @type {Number}
         * @constant
         */
        TO_SCREEN_AROUND_AXIS: 2
    }
    freezeObject(EnumRotateMode)
    /**
     * 反向查找对齐方式的名称。
     * 
     * @param {Number} value 对齐方式的数值。
     * @returns {String} 对齐方式的名称。
     */
    function getName(value) {
        for (var key in EnumRotateMode) {
            if (EnumRotateMode.hasOwnProperty(key) && EnumRotateMode[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        NO_ROTATE: 0,
        TO_SCREEN: 1,
        TO_SCREEN_AROUND_AXIS: 2,
        getName: getName
    }
})